import React from 'react';
import { StyledTextbox } from '@nib-components/textbox';
import MaskedInput from 'react-text-mask';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const LABELS = {
  ARHI: DEFAULT_LABELS.CREDIT_CARD_NUMBER
};
export const CARD_MASKS = {
  visa: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  masterCard: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  amex: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/]
};
const CARD_TYPE_PATTERNS = {
  '^4': 'visa',
  '^(?:2(?:2(?:2[1-9]|[3-9])|[3-6]|7(?:[0-1]|20))|5[1-5])': 'masterCard',
  '^3[47]': 'amex'
};
const mask = input => {
  // visa is popular so can be default if nothing found.
  let cardType = 'visa';
  Object.keys(CARD_TYPE_PATTERNS).forEach(item => {
    const pattern = new RegExp(item);
    if (pattern.test(input)) {
      cardType = CARD_TYPE_PATTERNS[item];
    }
  });
  return CARD_MASKS[cardType];
};
const CreditCardNumber = props => {
  const {
    funnel = FUNNELS.ARHI,
    help = '',
    width = 20,
    optional = false
  } = props;
  return React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    help: help,
    width: width,
    optional: optional
  }, React.createElement(MaskedInput, {
    guide: false,
    mask: mask,
    ...props.field,
    render: (ref, props) => React.createElement(StyledTextbox, {
      ...props,
      ref: ref,
      autoComplete: "cc-number",
      inputMode: "numeric",
      pattern: "(\\d\\d\\d\\d \\d\\d\\d\\d \\d\\d\\d\\d \\d\\d\\d\\d)|(\\d\\d\\d\\d \\d\\d\\d\\d\\d\\d \\d\\d\\d\\d\\d)|(\\d\\d\\d\\d \\d\\d\\d\\d \\d\\d\\d\\d \\d)"
    })
  }));
};
CreditCardNumber.defaultProps = defaultFieldPropTypes;
const CreditCardNumberWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(CreditCardNumber, {
  ...props
}));
export default CreditCardNumberWithFunnel;